import { Button } from '../../components/ui/button';
import { CheckCircle, Award, MapPin, Users, FileCheck, Phone } from 'lucide-react';

const TrustSection = () => {
  return (
    <section id="trust" className="py-16 md:py-20 bg-white border-y border-gray-100 relative overflow-hidden" data-testid="trust-section">
      {/* Subtle dot pattern background */}
      <div className="absolute inset-0 opacity-[0.4]" style={{ backgroundImage: 'radial-gradient(circle, #d1d5db 1px, transparent 1px)', backgroundSize: '24px 24px' }} />
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary/10 text-secondary text-sm font-medium mb-4">
            Pourquoi nous faire confiance ?
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Vous méritez mieux que des <span className="text-primary">promesses</span>
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Speak&Move apporte enfin des résultats. Voici ce qui nous distingue.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {/* Guarantee 1 - HIGHLIGHTED */}
          <div className="relative flex items-start gap-4 p-6 bg-white rounded-2xl border border-primary shadow-sm">
            {/* Micro-badge */}
            <span className="absolute -top-3 right-4 px-3 py-1 bg-primary text-white text-xs font-medium rounded-full">
              ⭐ Notre engagement
            </span>
            <div className="w-12 h-12 rounded-xl bg-secondary flex items-center justify-center shrink-0">
              <CheckCircle className="w-6 h-6 text-white" />
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-1">Votre succès, Notre priorité!</h3>
              <p className="text-sm text-gray-600">Un accompagnement fiable, transparent et orienté résultats.</p>
            </div>
          </div>

          {/* Guarantee 2 */}
          <div className="flex items-start gap-4 p-6 bg-white rounded-2xl border border-gray-100">
            <div className="w-12 h-12 rounded-xl bg-secondary flex items-center justify-center shrink-0">
              <Award className="w-6 h-6 text-white" />
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-1">Partenaire Goethe/TELC/ECL</h3>
              <p className="text-sm text-gray-600">Centre agréé pour les examens officiels d'allemand reconnus mondialement.</p>
            </div>
          </div>

          {/* Guarantee 3 - HIGHLIGHTED */}
          <div className="relative flex items-start gap-4 p-6 bg-white rounded-2xl border border-primary shadow-sm">
            {/* Micro-badge */}
            <span className="absolute -top-3 right-4 px-3 py-1 bg-primary text-white text-xs font-medium rounded-full">
              📍 Disponible et joignable
            </span>
            <div className="w-12 h-12 rounded-xl bg-secondary flex items-center justify-center shrink-0">
              <MapPin className="w-6 h-6 text-white" />
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-1">Disponible et joignable à tout moment</h3>
              <p className="text-sm text-gray-600">En physique, via WhatsApp, appel ou visio — on est disponibles quand vous en avez besoin aussi bien au Cameroun qu'en France.</p>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default TrustSection;
